export const clearFilterData = {
  AptTmSt: null,
  AptTmEn: null,
  StsTmSt: null,
  StsTmEn: null,
  DrvId: null,
  SalDte: null,
  JobOrdId: null,
  ContNo: null,
  JobId: null,
  PaySts: null,
  IsFilterSalDte: 1
}

export const initFilterData = {
  ...clearFilterData
}

export const initAddDriverTripDialogData = {
  PayTm: "",
  UsrAccId: "",
  JobOrdId: null,
  Loc: "",
  ExpId: null,
  Amnt: 0,
  Dscp: "",
  Rmk: "",
}